import React, { useEffect, useState } from 'react';
import './catalog.scss';
import { Card, Button, Modal, Form, Input, Spin } from 'antd';
import { useLocation } from 'react-router-dom';
import DeleteIcon from '../../../../src/assets/images/delete_icon.svg';
import EditIcon from '../../../../src/assets/images/edit_icon.svg';
import { useDispatch, useSelector } from 'react-redux';
import { addCatalogue, deleteCatalogue, getCatalogue, updateCatalogue } from '../../../slices/catalog/thunk';
import NoResults from '../../Components/NoResults/NoResults';
import { getVerifiedStatus } from '../../../Services/LocalStorageService';
import InfiniteScroll from 'react-infinite-scroll-component';
import { ShimmerSimpleGallery } from "react-shimmer-effects";
import MobileView from '../MobileView/MobileView';
import mobilePreviewIcon from '../../../assets/images/mobile_preview_icon.svg'
import { getDashboard } from '../../../slices/dashboard/thunk';
import { catalogStatusUpdate } from '../../../Services/AdsStatusService';
import ProfileNotVerifiedPopup from '../../../Common/profileNotVerifiedPopup/ProfileNotVerifiedPopup';
import { validationContent } from '../../../constants/Validation';
import { Popup_Toast } from '../../../constants/Popups_Toast';
import { PlaceholderContent } from '../../../constants/Placeholder';


const Catalog = () => {
    document.title = "Catalogue";

    let content = validationContent?.CATALOG_CREATION;
    let placeholderContent = PlaceholderContent?.CATALOG_CREATION;
    let popupContent = Popup_Toast;
    const dispatch = useDispatch();
    let adminVerificationStatus = useSelector((state) => state.Dashboard?.adminVerificationStatus);
    const catalogueData = useSelector((state) => state.Catalog);
    const [loading, setLoading] = useState(false);
    const isReload=useSelector((state)=>state.GlobalReload.isReload)
    useEffect(() => { }, [isReload]);

    const [status, setStatus] = useState(false);
    const [catalogData, setCatalogData] = useState(catalogueData.data || []);
    const [modalVisible, setModalVisible] = useState(false);
    const [editingElement, setEditingElement] = useState(null);
    const [fileList, setFileList] = useState([]);
    const [form] = Form.useForm();
    const [selectedCatalog, setSelectedCatalog] = useState();
    const [errorVerificationModal, setErrorVerificationModal] = useState();
    const [hasMore, setHasMore] = useState(true);
    const [page, setPage] = useState(1);
    const limit = 5;
    const [hasFetchData, setHasFetchData] = useState(false);
    const [catalogBtnDisable, setCatalogBtnDisable] = useState(true);
    // Delete
    const [deletedCatalog, setDeletedCatalog] = useState();
    // changed catalog
    const [changedCatalog, setChangedCatalog] = useState();
    const [trigger, setTrigger] = useState({ 'update': false, 'create': false })
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [mobilePreview, setMobilePreview] = useState(false);
    const [initialLoading, setInitialLoading] = useState(true);
    const [profileNotVerifiedModal, setProfileNotVerifiedModal] = useState(false);
    const [catalogDescriptionLength, setCatalogDescriptionLength] = useState(0);
    useEffect(() => {
        dispatch(getDashboard());
    }, [])
    // Handle modal confirm
    const handleOk = async () => {
        setIsModalOpen(false);
        await removeCatalog(selectedCatalog);
        setSelectedCatalog(null);
    };

    const fetchMoreData = async () => {
        if (!hasMore || catalogueData.loading) return; // Prevent additional calls if no more data or still loading

        try {
            setPage((prevPage) => prevPage + 1); // Increment the page state
            const response = await dispatch(getCatalogue({ limit, page: page + 1 }));

            if (response?.payload?.length < limit) {
                setHasMore(false);
            }
        } catch (error) {
            console.error("Error fetching more data:", error);
        }
    };

    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [pathname]);

    const editFunctionality = (el) => {
        setEditingElement(el);
        setFileList(el.image ? [{ uid: '-1', name: 'image.png', status: 'done', url: el.image }] : []);
        setModalVisible(true);
        setFormField(el)
    };

    const showModal = () => {
        setCatalogBtnDisable(true)
        setEditingElement()
        // if (!status) {
        //     setProfileNotVerifiedModal(prev => !prev)
        // } else {
        //     setModalVisible(true);
        // }
        setModalVisible(true);
    };

    const handleCancel = () => {
        setCatalogDescriptionLength(0);
        setIsModalOpen(false);
        setModalVisible(false);
        form.resetFields();
        setFileList([]);
        setErrorVerificationModal(false);
    };

    const onFinish = async (values) => {
        handleCancel();
        const dataToSend = {
            price: parseFloat(values.price),
            title: values.title,
            description: values.description
        };

        if (editingElement) {
            setLoading(true);
            let updatedData = { id: editingElement._id, ...dataToSend };
            try {
                let response = await dispatch(updateCatalogue(updatedData));
                if (response?.payload?.statusCode === 200) {
                    setTrigger((prev) => ({
                        ...prev, 'update': true
                    }))
                }
                // await dispatch(getCatalogue({ limit: limit, page: page }));
            } catch (error) {
                console.error('Error updating catalogue:', error);
            } finally {
                setLoading(false);
            }
        } else {
            try {
                setLoading(true);
                const response = await dispatch(addCatalogue(dataToSend));
                setTrigger((prev) => ({
                    ...prev, 'create': true
                }))
                setPage(1)
            } catch (error) {
                console.error('Error adding to catalogue:', error);
            } finally {
                setLoading(false);
                dispatch(getCatalogue({ limit: limit, page: 1 }))
            }
        }


    };



    const handleUploadChange = ({ fileList }) => {
        setFileList(fileList);
    };

    // useEffect(() => {
    //     if (editingElement) {
    //         form.setFieldsValue({
    //             title: editingElement.title,
    //             description: editingElement.description,
    //             price: editingElement.price,
    //         });
    //     }
    // }, [editingElement, form]);

    function setFormField(currentElement) {
        form.setFieldsValue({
            title: currentElement.title,
            description: currentElement.description,
            price: currentElement.price,
        });
    }

    useEffect(() => {
        if (catalogueData.data) {
            setCatalogData((prev) => {
                if (page === 1) {
                    return catalogueData.data
                }
                else {
                    let filteredCatalogs = catalogueData.data.filter((catalog) =>
                        !prev.some((prevAd) => prevAd?._id === catalog?._id)
                    );
                    return catalogueData.data.length > 0 ? [...prev, ...filteredCatalogs] : prev;
                }
            });
        }

    }, [catalogueData.data, page]);




    useEffect(() => {

        dispatch(getCatalogue({ limit, page }));
        setHasFetchData(true)
    }, [dispatch, page]);

    useEffect(() => {
        if (adminVerificationStatus) {
            setStatus(adminVerificationStatus)
        }
    }, [adminVerificationStatus])

    useEffect(() => {
        if (!catalogueData.loading) {
            const isMoreAvailable = catalogueData.data?.length >= limit;
            setHasMore(isMoreAvailable);
        }
    }, [catalogueData.data, catalogueData.loading]);

    const onFieldsChange = (changedFields, allFields) => {
        let titleValid = false;
        let descriptionValid = false;



        allFields.forEach(({ name, value }) => {
            setChangedCatalog((prev) => ({
                ...prev, [name]: value  // Use name as the key
            }));

            if (name[0] === 'title') {
                if (value?.replace(/\s+/g, '')?.length >= 3) {
                    titleValid = true;
                }
            }
            if (name[0] === 'description') {
                if (value?.replace(/\s+/g, '')) {
                    setCatalogDescriptionLength(value?.length)
                    if (value.length >= 5) {
                        descriptionValid = true;
                    }
                }
            }
        });

        setCatalogBtnDisable(!(titleValid && descriptionValid));
    };
    useEffect(() => {
        if (!catalogueData.loading) {
            setInitialLoading(false);
        }
    }, [catalogueData.loading]);

    useEffect(() => {
        console.log('deletedCatalog', deletedCatalog)
        if (deletedCatalog) {
            setCatalogData((prev) =>
                prev?.filter((catalog) => catalog?._id !== deletedCatalog)
            );
        }
    }, [deletedCatalog]);

    // useEffect(() => {
    //     if (trigger?.update && editingElement) {
    //         let changedCatalogId = editingElement._id;
    //         setCatalogData((prev) =>
    //             prev.map((el) =>
    //                 el?._id === changedCatalogId
    //                     ? { ...el, title: changedCatalog?.title, description: changedCatalog?.description, status: catalogStatusUpdate("reviewing"), price: changedCatalog?.price }
    //                     : el
    //             )
    //         );
    //         setEditingElement(null);
    //         setTrigger((prev) => ({
    //             ...prev,
    //             update: false
    //         }));

    //     }
    //     if (trigger?.create) {
    //         setCatalogData((prev) => [
    //             {
    //                 title: changedCatalog?.title,
    //                 description: changedCatalog?.description,
    //                 status: catalogStatusUpdate('pending'),
    //                 price: changedCatalog?.price,
    //             }
    //             , ...prev
    //         ]);
    //         setTrigger((prev) => ({
    //             ...prev,
    //             create: true
    //         }));


    //     }
    // }, [changedCatalog]);
    function creatingCatalog() {
        dispatch(getCatalogue({ limit: limit, page: 1 }))
        setPage(1)
        setTrigger((prev) => ({
            ...prev, 'create': false
        }))
        // setCatalogData((prev) => [
        //     {
        //         title: changedCatalog?.title,
        //         description: changedCatalog?.description,
        //         verification_status: 0,
        //         price: changedCatalog?.price ? changedCatalog?.price : 0
        //     }
        //     , ...prev
        // ]);

    } function updatingCatalog() {
        let changedCatalogId = editingElement._id;
        if (catalogData) {
            setCatalogData((prev) =>
                prev
                    .filter(Boolean) // Remove null entries
                    .map((el) =>
                        el?._id === changedCatalogId
                            ? {
                                ...el,
                                title: changedCatalog?.title,
                                description: changedCatalog?.description,
                                verification_status: 4,
                                price: changedCatalog?.price ? changedCatalog?.price : 0,
                                warning: null,
                                status: 'reviewing'
                            }
                            : el
                    )
            );
        }
        setTrigger((prev) => ({
            ...prev, 'update': false
        }))
    }
    useEffect(() => {
        if (trigger?.update && catalogData) {
            updatingCatalog();
        }
        if (trigger?.create && catalogData) {
            creatingCatalog();
        }
    }, [trigger, catalogData])

    const removeCatalog = async (el) => {
        try {
            setLoading(true);
            const response = await dispatch(deleteCatalogue(el._id));

            if (response?.meta?.requestStatus === 'fulfilled') {
                setDeletedCatalog(el?._id)
            }
        } catch (error) {
            console.error("Error deleting catalogue:", error);
        } finally {
            setLoading(false);
        }
    };

    const beforeUpload = (file) => {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
            Modal.error({
                title: 'Invalid file type',
                content: 'You can only upload JPG/PNG file!',
            });
        }
        return isJpgOrPng;
    };


    useEffect(() => {
        console.log('catalogData', catalogData)
    }, [catalogData])




    return (
        <>
            <div className="parent_wrap">
                {((catalogueData.loading && initialLoading) || loading) && (
                    <div className="spinner center" key={0}>
                        <Spin />
                    </div>
                )}

                <InfiniteScroll
                    dataLength={catalogData.length}
                    next={fetchMoreData}
                    hasMore={hasMore}
                    loader={
                        catalogueData.loading && (
                            <div className="spinner center">
                                <Spin />
                            </div>
                        )
                    }
                // endMessage={ hasFetchData && (
                //     <p className='no_more_text'>No more items to load</p>
                // )}
                >
                    <Button className={`mobile_preview_toggle ${mobilePreview && 'active'}`} onClick={() => {
                        setMobilePreview((prev) => !prev)
                    }}>
                        <figure>
                            <svg xmlns="http://www.w3.org/2000/svg" width="62.138" height="63.9" viewBox="0 0 62.138 63.9">
                                <g id="Group_1" data-name="Group 1" transform="translate(-4 -3)">
                                    <path id="Path_1" className='svg-path' data-name="Path 1" d="M65,33.9a42.465,42.465,0,0,0-12.3-9.5V11.5A8.493,8.493,0,0,0,44.2,3H12.5A8.493,8.493,0,0,0,4,11.5V58.4a8.493,8.493,0,0,0,8.5,8.5H44.3a8.493,8.493,0,0,0,8.5-8.5V48.8a42.152,42.152,0,0,0,12.3-9.5A3.9,3.9,0,0,0,65,33.9ZM34.7,8.1l-1.2,3.8H23.2L22,8.1Zm13,50.4A3.543,3.543,0,0,1,44.2,62H12.4a3.543,3.543,0,0,1-3.5-3.5v-47A3.543,3.543,0,0,1,12.4,8h4.2l1.9,5.8a4.416,4.416,0,0,0,4.2,3H33.9a4.416,4.416,0,0,0,4.2-3L40,8.1h4.2a3.543,3.543,0,0,1,3.5,3.5v11a3.553,3.553,0,0,0-1-.2c-.3-.1-.6-.1-.9-.2a5.019,5.019,0,0,0-1.2-.2,1.268,1.268,0,0,1-.6-.1c-.6,0-1.1-.1-1.7-.1h-.1c-10.7,0-19.5,8.4-22.7,12.1a4.126,4.126,0,0,0,0,5.5c3.3,3.6,12,12,22.7,12h.3a7.084,7.084,0,0,0,1.4-.1,1.7,1.7,0,0,0,.7-.1c.3,0,.6-.1.9-.1.6-.1,1.2-.2,1.7-.3a.367.367,0,0,0,.3-.1v7.8ZM49,45c-.4.2-.9.3-1.3.5-.1,0-.3.1-.4.1-.5.1-.9.3-1.4.4a.367.367,0,0,0-.3.1c-.5.1-1.1.2-1.6.3h-.1a9.7,9.7,0,0,1-1.7.1c-8.3,0-15.6-6.8-18.4-9.7C26.6,33.9,33.9,27,42.2,27a8.6,8.6,0,0,1,1.6.1.756.756,0,0,1,.4.1c.4.1.9.1,1.3.2.2,0,.3.1.5.1l1.2.3c.2.1.4.1.6.2.4.1.7.3,1.1.4,5.4,2.1,9.8,6.3,11.8,8.4-2,2-6.4,6.1-11.7,8.2Z" fill="#ef6f6f" />
                                    <path id="Path_2" className='svg-path' data-name="Path 2" d="M46.1,35.1a2.506,2.506,0,0,0-.4-.7,4.313,4.313,0,0,0-1.1-1.1c-.2-.1-.5-.3-.7-.4a1.884,1.884,0,0,0-.8-.2,4.165,4.165,0,0,0-3.7,1.1,4,4,0,0,0-1.2,2.9,3.847,3.847,0,0,0,1.2,2.9,4,4,0,0,0,2.9,1.2,2.2,2.2,0,0,0,.8-.1,2.353,2.353,0,0,0,.8-.2,2.506,2.506,0,0,0,.7-.4,2.651,2.651,0,0,0,.6-.5,4,4,0,0,0,1.2-2.9,2.2,2.2,0,0,0-.1-.8A1.884,1.884,0,0,0,46.1,35.1Z" fill="#ef6f6f" />
                                </g>
                            </svg>
                        </figure>
                    </Button>
                    <section className="catalog_block content_mobileView_wrap block">
                        <Card >
                            <div className={` catalog_title ${!catalogData.length > 0 && 'no_data'}`} style={{ display: 'flex', alignItems: 'center', marginBottom: '1.5em', justifyContent: 'space-between' }}>
                                {
                                    catalogData.length > 0 && (
                                        <h4 className='text_md' style={{ fontWeight: '500' }}>My Catalogue</h4>
                                    )
                                }
                                <Button style={{ marginBottom: 0 }} type="primary" onClick={showModal} className='short'>
                                    + Add
                                </Button>
                            </div>
                            <div className="catalog_wrap">
                                {catalogData.length > 0 ? (
                                    catalogData.filter(el => el !== undefined).map((el, index) => {
                                        let { className, message } = catalogStatusUpdate(el?.verification_status);
                                        return (
                                            <div className={`catalog_cnt ${el?.verification_status !== 1 ? 'bottom_spacing' : ''} ${className}`} key={index}>
                                                <div className="catalog_info" style={{ display: 'flex', justifyContent: "space-between" }}>
                                                    <div className="catalog_inner full_width">
                                                        <div>
                                                            <h4 className="text_md" style={{ marginBottom: '.7em', fontWeight: '600' }}>
                                                               {el?.title && <span className='capitalize'>{el.title}</span>}
                                                            </h4>

                                                            <div className='description_cnt'>
                                                                {el?.description.split('\n').map((line, index) => (
                                                                    <p className="text_md" key={index}>
                                                                        {line}
                                                                    </p>
                                                                ))}
                                                            </div>
                                                        </div>

                                                        {(el?.price || el?.price !== 0) && (
                                                            <Button className="reverse_btn text_md" style={{ padding: '.5em 1em' }}>
                                                                ₹{el?.price}
                                                            </Button>
                                                        )}
                                                    </div>
                                                    <div className="button_wrap">
                                                        <Button className='edit_btn' onClick={() => editFunctionality(el)}>
                                                            <img src={EditIcon} alt="Edit" className='icon' />
                                                        </Button>
                                                        <Button className='delete_btn' onClick={() => {
                                                            setIsModalOpen(true);
                                                            setSelectedCatalog(el);
                                                        }}>
                                                            <img src={DeleteIcon} alt="Delete" className='icon' />
                                                        </Button>
                                                    </div>
                                                </div>
                                                {/* Status Warning Section */}
                                                <div className={`catalog_warning ${className}`}>
                                                    {el?.status === 'rejected' ? (
                                                        <>
                                                            <div>
                                                                <h2 class="text_md">{el?.warning?.title}</h2>
                                                                <p class="md">{el?.warning?.description}</p>
                                                            </div>
                                                        </>
                                                    ) : <p>{message}</p>}
                                                </div>
                                            </div>
                                        );
                                    })
                                ) : (
                                    <NoResults
                                        type={'catalog'}
                                        title={'Create Your Catalogue'}
                                        description={'Showcase your catalogue item to customers by uploading your latest catalogues. These will be visible on your business page for all to see!'}>
                                    </NoResults>
                                )}
                            </div>
                        </Card>
                        <MobileView className={mobilePreview && 'active'} type={'withoutText'} active='4' updatedCatalogData={catalogData} fromCatalogData={true} />
                        <Modal
                            className="catalog_add_form form_wrap center_modal add_catalog"
                            afterClose={() => (document.body.style.overflow = 'initial')}
                            visible={modalVisible}
                            footer={[
                                <div className='text-center '>
                                    <Button key="submit" type="primary" form="myForm" htmlType="submit" disabled={catalogBtnDisable}>
                                        Submit
                                    </Button>
                                    <Button key="close" type="text" className="short custom_btn" onClick={() => [
                                        handleCancel(),
                                    ]}>
                                        Close
                                    </Button>
                                </div>,
                            ]}
                            onCancel={handleCancel}
                        >
                            <Form
                                id="myForm"
                                form={form}
                                onFinish={onFinish}
                                onFieldsChange={onFieldsChange}
                            >
                                <h2 className="text-center text_lg text_red">Add Catalogue Item</h2>
                                <div className="description_wrap">
                                    <Form.Item label="Title" name="title" rules={[{ message: content?.MissingTitle }]}>
                                        <Input
                                            placeholder={placeholderContent?.Title} maxLength={50}
                                        />
                                    </Form.Item>
                                    <div className="note_parent">
                                        <span class="form_note"><span className="text_red">* </span>Enter at least 3 characters.</span>
                                    </div>
                                </div>
                                <div className="description_wrap">
                                    <Form.Item label="Description" name="description" rules={[{ message: content?.MissingDescription }]}>
                                        <Input.TextArea maxLength={500} placeholder={placeholderContent?.Description} className='text_transform_normal description' style={{ resize: 'none' }} />
                                    </Form.Item>
                                    <div className="note_parent">
                                        <span class="form_note"><span className="text_red">* </span>Enter at least 5 characters.</span>
                                        <span class={` form_note ${catalogDescriptionLength === 500 && 'limit'}`} ><span>{catalogDescriptionLength}</span>/500</span>
                                    </div>
                                </div>
                                <Form.Item label="Price" name="price" >
                                    <Input placeholder={placeholderContent?.Price} type="text" maxLength={10} onKeyDown={(e) => { if (!(e.key === 'Backspace' || e.key === 'Delete' || /^\d$/.test(e.key))) { e.preventDefault(); } }} />
                                </Form.Item>
                            </Form>
                        </Modal>
                        <Modal className='sm_modal work_modal center_modal' afterClose={() => (document.body.style.overflow = 'initial')} open={isModalOpen} footer={[
                            <div className='text-center'>
                                <Button key="submit" type="primary" className='short wide' onClick={handleOk}>
                                    Confirm
                                </Button>
                                <Button key="close" type="text" className="short custom_btn" onClick={handleCancel}>
                                    Close
                                </Button>
                            </div>
                        ]} onCancel={handleCancel}>
                            <h2 className="text_lg text_red">
                                {popupContent?.DELETE_CATALOG?.content?.title}
                            </h2>
                            <p className="md">{popupContent?.DELETE_CATALOG?.content?.description}</p>
                        </Modal>
                        <ProfileNotVerifiedPopup status={profileNotVerifiedModal} />
                    </section>
                </InfiniteScroll>
            </div>
        </>
    );
};

export default Catalog;

